import styles from "./App.module.css";
import { BrowserRouter } from 'react-router-dom';
import { useState } from "react";
import Header from './components/Layout/Header';
import Router from "./Router";

function App() {

  const [showHeader, setShowHeader] = useState(true);

  return (
    <BrowserRouter>
      <div className={styles.app}>
        {showHeader && <Header />}
        <Router setShowHeader={setShowHeader} />
      </div>
    </BrowserRouter>
  )
}

export default App;
